import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Columns from 'components/common/Columns/Columns'
import Link from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'
import SizeDetails from '../SizeDetails'
import { Title, SubTitle, Circle, IncompatibleDrawer } from '../SharedStyles'
import { arrayHasValues } from 'helpers/utils'
import { isMobile } from 'components/common/Media/helpers'

const BOTTireSizeDetailsCartridge = ({
  incompartibleTireSizes = [],
  compartibleTireSizes = [],
  eligibleTires,
  activeVehicleName,
  tireSizes = [],
  showShopEligibleTires,
  ...props
}) =>
  <Fragment>
    <Title headline headline_narrow size="30">Available Sizes</Title>
    <StyledColumns adaptive width="50% 50%" >
      {
        !!compartibleTireSizes.length &&
        <Fragment>
          <SubTitle { ...props }>
            Currently compatible with your { activeVehicleName }
            <Circle asset="check-circle" width={ 20 } height={ 20 } />
          </SubTitle>
          {
            compartibleTireSizes.map(({ diameter, sizes }) =>
              <SizeDetails
                key={ diameter }
                sizes={ sizes }
                diameter={ diameter } />
            )
          }
        </Fragment>
      }
      {
        arrayHasValues(incompartibleTireSizes) &&
        <Media.Desktop>
          <SubTitle { ...props }>Currently incompatible with your {activeVehicleName} </SubTitle>
          {
            incompartibleTireSizes.map(({ diameter, sizes }) =>
              <SizeDetails
                key={ diameter }
                sizes={ sizes }
                diameter={ diameter } />
            )
          }
          {
            showShopEligibleTires &&
            <Link button to={ eligibleTires }>Shop eligible tires</Link>
          }
        </Media.Desktop>
      }
      {
        isMobile() &&
        <Media.Mobile>
          <IncompatibleDrawer shade accordion title={ `Currently incompatible with your ${activeVehicleName}` }>
            <Fragment>
              {
                incompartibleTireSizes.map(({ diameter, sizes }) =>
                  <SizeDetails
                    key={ diameter }
                    sizes={ sizes }
                    diameter={ diameter } />
                )
              }
              {
                showShopEligibleTires &&
                <Link button full to={ eligibleTires }>Shop eligible tires</Link>
              }
            </Fragment>
          </IncompatibleDrawer>
        </Media.Mobile>
      }
    </StyledColumns>
  </Fragment>

BOTTireSizeDetailsCartridge.propTypes = {
  activeVehicleName: PropTypes.string,
  compartibleTireSizes: PropTypes.arrayOf(PropTypes.shape()),
  eligibleTires: PropTypes.string,
  incompartibleTireSizes: PropTypes.arrayOf(PropTypes.shape()),
  showShopEligibleTires: PropTypes.bool,
  tireSizes: PropTypes.arrayOf(PropTypes.shape())
}

export default BOTTireSizeDetailsCartridge

const StyledColumns = styled(Columns)`
  [data-column]:first-child {
    ${Media.desktop`
      border-right: 1px solid ${Theme.colors.grey};
    `}
  }

  [data-column]:first-child + [data-column] {
    padding-left: 25px;
  }

  [data-column]:first-child:last-child {
    border-right: none;
  }
`
